module.exports = __webpack_public_path__ + "static/media/AFTER-trail-exercises.f181fb7f.mp3";